import { render, staticRenderFns } from "./ObjectStorageImageuploader.vue?vue&type=template&id=5848aa6a&scoped=true"
import script from "./ObjectStorageImageuploader.vue?vue&type=script&lang=js"
export * from "./ObjectStorageImageuploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848aa6a",
  null
  
)

export default component.exports